import React from 'react';
import { motion } from 'framer-motion';
import { Target, Gauge, TrendingUp, ArrowUpRight } from 'lucide-react';
const features = [{
  icon: Target,
  title: 'Precision Targeting',
  description: 'AI-driven task allocation ensures zero redundancy in your operational workflow.',
  stat: '99.9%'
}, {
  icon: Gauge,
  title: 'Velocity Control',
  description: 'Adjust automation speeds dynamically to match your business scaling requirements.',
  stat: '0.05s'
}, {
  icon: TrendingUp,
  title: 'Growth Metrics',
  description: 'Real-time analytics dashboard providing deep insights into efficiency gains.',
  stat: '+24x'
}];
export function Features() {
  return <section className="py-32 bg-gray-50 border-t border-gray-100" data-id="element-15">
      <div className="container mx-auto px-6" data-id="element-16">
        <div className="mb-20 max-w-2xl" data-id="element-17">
          <h2 className="text-4xl font-black tracking-tight mb-6" data-id="element-18">
            Engineered for <span className="text-[#84cc16]" data-id="element-19">Efficiency</span>
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-20">
            Our Swiss-inspired architecture delivers uncompromising performance
            and reliability.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-21">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -10
        }} className="group relative bg-white p-10 border border-gray-200 hover:border-[#84cc16] transition-colors duration-300 shadow-sm hover:shadow-xl" data-id="element-22">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#84cc16] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" data-id="element-23" />

              <div className="flex justify-between items-start mb-8" data-id="element-24">
                <div className="p-3 bg-gray-50 group-hover:bg-[#84cc16]/10 transition-colors rounded-none" data-id="element-25">
                  <feature.icon className="w-8 h-8 text-black" strokeWidth={1.5} data-id="element-26" />
                </div>
                <span className="text-3xl font-black text-gray-200 group-hover:text-[#84cc16] transition-colors" data-id="element-27">
                  {feature.stat}
                </span>
              </div>

              <h3 className="text-2xl font-bold mb-4 tracking-tight group-hover:text-[#84cc16] transition-colors" data-id="element-28">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-29">
                {feature.description}
              </p>

              <div className="mt-8 flex items-center text-sm font-bold opacity-0 group-hover:opacity-100 transition-opacity transform translate-y-2 group-hover:translate-y-0" data-id="element-30">
                Learn more <ArrowUpRight className="ml-2 w-4 h-4" data-id="element-31" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}